var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes.light.background }),attrs:{"id":"inspire"}},[_c('router-view'),_c('app-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }